import * as yup from 'yup';

import { DIAGNOSTIC_CARD_VALUE_FIELDS, PTS_VALUE_FIELDS, VALUE_FIELDS } from './constants';

const transformToType = (type, defaultValue) => {
  return (value) => {
    return typeof value === type ? value : defaultValue;
  };
};

const customNumber = yup
  .mixed()
  .test('not_number_not_null', 'не верное значение', (value) => {
    // eslint-disable-next-line eqeqeq
    return typeof Number(value) === 'number' || value == null;
  })
  .transform(transformToType('number', null));
const customBool = yup.bool().transform(transformToType('boolean', false));
const customString = yup.string().transform(transformToType('string', ''));

export const schema = yup.object().shape({
  [VALUE_FIELDS.BODY_NUMBER]: customString,
  [VALUE_FIELDS.BRAND]: customString,
  [VALUE_FIELDS.CAR_ISSUE_DATE]: customString,
  [VALUE_FIELDS.DEFAULT_PRICE]: customNumber,
  [VALUE_FIELDS.DIAGNOSTIC_CARD]: yup
    .object()
    .shape({
      [DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]: customString,
      [DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]: customString,
      [DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]: customString,
    })
    .required(),
  [VALUE_FIELDS.ENGINE_NUMBER]: customString,
  [VALUE_FIELDS.ENGINE_POWER]: customNumber,
  [VALUE_FIELDS.ENGINE_VOLUME]: customString,
  [VALUE_FIELDS.GLONAS_NUMBER]: customString,
  [VALUE_FIELDS.ID]: yup.number().required(),
  [VALUE_FIELDS.IS_NEW]: customBool,
  [VALUE_FIELDS.MILEAGE]: customNumber,
  [VALUE_FIELDS.MODEL]: customString,
  [VALUE_FIELDS.OFFER_PRICE]: customNumber,
  [VALUE_FIELDS.PERMITTED_MAX_WEIGHT]: customNumber,
  [VALUE_FIELDS.PRICE]: customNumber,
  [VALUE_FIELDS.PTS]: yup
    .object()
    .shape({
      [PTS_VALUE_FIELDS.ISSUE_DATE]: customString,
      [PTS_VALUE_FIELDS.NUMBER]: customString,
      [PTS_VALUE_FIELDS.SERIES]: customString,
    })
    .required(),
  [VALUE_FIELDS.VERSION]: customString,
  [VALUE_FIELDS.VIN]: customString,
  [VALUE_FIELDS.YEAR]: customNumber,
});

export default schema;
